export const getDocsLoading = (state) => state.docs.loading;
export const getDocsError = (state) => state.docs.error;
export const getCurrentDocPath = (state) => state.docs.currentDocPath;
export const getDocFromCache = (state, docPath) =>
  state.docs.cache[docPath] || null;
export const getSearchQuery = (state) => state.docs.searchQuery;
export const getSearchResults = (state) => state.docs.searchResults;
export const getSearchLoading = (state) => state.docs.searchLoading;
